import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";

const Wrapper = styled.div`
  font-family: ${({ theme }) => theme.fontParagraphs.fontFamily};
  width: 100%;
  display: flex;
  flex-direction: column;
`;
const Question = styled.div`
  cursor: pointer;
  align-items: center;
`;
const Text = styled.div`
  padding: 1rem 1.5rem;
  padding-left: 1.2rem;
  display: flex;
  justify-content: flex-start;
`;
const CloseIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.black};
  margin-right: 1rem;
`;
const Answer = styled.div`
  display: flex;
  background-color: ${({ theme }) => theme.colors.white};
  opacity: 0;
  max-height: 0;
  overflow: hidden;
  visibility: hidden;
  transition: all 0.2s ease-in;

  &.visible {
    opacity: 1;
    max-height: 100%;
    visibility: visible;
  }
  span {
    padding: 1.5rem 3.5rem;
  }
`;

export default function Accordion({ question, answer }) {
  const [isOpen, setOpen] = React.useState(false);

  const toggleAnswer = () => {
    setOpen(!isOpen);
  };

  return (
    <Wrapper>
      <Question
        itemScope
        itemProp="mainEntity"
        itemType="https://schema.org/Question"
        onClick={toggleAnswer}
      >
        <Text>
          <CloseIcon icon={isOpen ? faMinus : faPlus} size="1x" />{" "}
          <span
            itemProp="name"
            dangerouslySetInnerHTML={{ __html: question }}
          ></span>
        </Text>
        <Answer
          itemScope
          itemProp="acceptedAnswer"
          itemType="https://schema.org/Answer"
          className={isOpen ? "visible" : ""}
        >
          <span
            itemProp="text"
            dangerouslySetInnerHTML={{ __html: answer }}
          ></span>
        </Answer>
      </Question>
    </Wrapper>
  );
}

Accordion.propTypes = {
  question: PropTypes.string,
  answer: PropTypes.string,
};

Accordion.defaultProps = {
  question: undefined,
  answer: undefined,
};
